// extracted by mini-css-extract-plugin
export default {"container":"style_container__gJ6vz","tablesWrapper":"style_tablesWrapper__Y1NUp","showDetailButton":"style_showDetailButton__Kd62U"};